import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenu, setMobileMenu] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenu(false);
    }
  };

  return (
    <header style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      zIndex: 1000,
      background: scrolled ? 'rgba(0, 0, 0, 0.95)' : 'transparent',
      backdropFilter: scrolled ? 'blur(10px)' : 'none',
      borderBottom: scrolled ? '1px solid rgba(212, 175, 55, 0.2)' : 'none',
      transition: 'all 0.3s ease'
    }}>
      <nav style={{
        maxWidth: '1400px',
        margin: '0 auto',
        padding: '20px 40px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}>
        <div style={{
          fontFamily: 'Playfair Display, serif',
          fontSize: '28px',
          fontWeight: '700',
          color: '#D4AF37',
          letterSpacing: '2px'
        }}>
          SYSTEM
        </div>

        {/* Desktop Menu */}
        <ul style={{
          display: 'flex',
          listStyle: 'none',
          gap: '40px',
          margin: 0,
          padding: 0
        }} className="desktop-menu">
          {['Serviços', 'Portfólio', 'Depoimentos', 'FAQ'].map((item, idx) => (
            <li key={idx}>
              <button
                onClick={() => scrollToSection(item.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''))}
                style={{
                  background: 'none',
                  border: 'none',
                  color: '#FFFFFF',
                  fontFamily: 'Montserrat, sans-serif',
                  fontSize: '14px',
                  fontWeight: '500',
                  letterSpacing: '1px',
                  transition: 'color 0.3s ease',
                  textTransform: 'uppercase'
                }}
                onMouseEnter={(e) => e.target.style.color = '#D4AF37'}
                onMouseLeave={(e) => e.target.style.color = '#FFFFFF'}
              >
                {item}
              </button>
            </li>
          ))}
          <li>
            <button
              onClick={() => window.open('https://wa.me/5562995664918?text=Olá! Gostaria de solicitar um orçamento.', '_blank')}
              className="btn-primary"
              style={{ padding: '12px 30px', fontSize: '14px' }}
            >
              CONTATO
            </button>
          </li>
        </ul>

        {/* Mobile Menu Button */}
        <button
          onClick={() => setMobileMenu(!mobileMenu)}
          style={{
            background: 'none',
            border: 'none',
            color: '#D4AF37',
            display: 'none'
          }}
          className="mobile-menu-btn"
        >
          {mobileMenu ? <X size={28} /> : <Menu size={28} />}
        </button>
      </nav>

      {/* Mobile Menu */}
      {mobileMenu && (
        <div style={{
          background: 'rgba(0, 0, 0, 0.98)',
          padding: '30px 40px',
          borderTop: '1px solid rgba(212, 175, 55, 0.2)'
        }} className="mobile-menu-content">
          <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
            {['Serviços', 'Portfólio', 'Depoimentos', 'FAQ', 'Contato'].map((item, idx) => (
              <li key={idx} style={{ marginBottom: '20px' }}>
                <button
                  onClick={() => {
                    if (item === 'Contato') {
                      window.open('https://wa.me/5562995664918?text=Olá! Gostaria de solicitar um orçamento.', '_blank');
                    } else {
                      scrollToSection(item.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''));
                    }
                  }}
                  style={{
                    background: 'none',
                    border: 'none',
                    color: '#FFFFFF',
                    fontFamily: 'Montserrat, sans-serif',
                    fontSize: '18px',
                    fontWeight: '500',
                    width: '100%',
                    textAlign: 'left'
                  }}
                >
                  {item}
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}

      <style>{`
        @media (max-width: 768px) {
          .desktop-menu {
            display: none !important;
          }
          .mobile-menu-btn {
            display: block !important;
          }
        }
      `}</style>
    </header>
  );
};

export default Header;